import { Blank } from 'grommet-icons';
import { components } from './components';

const structure = [
  {
    name: 'Design',
    Icon: Blank,
    components: [
      'Alternative',
      'Icon',
      'IFrame',
      'Repeater',
      'Reference',
      'Screen',
    ],
  },
];

const index = {
  name: 'designer',
  components,
  structure,
};

export default index;
